export default __webpack_public_path__ + "signup-backdrop-freelancer.f20488fc.jpg";